import type { CheckError, CheckRequest, CheckResult, FeedbackRequest } from "../core/types.js";

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || "";

export async function runCheck(request: CheckRequest): Promise<CheckResult> {
  const response = await fetch(`${apiBaseUrl}/api/check`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(request)
  });

  return readJsonResponse<CheckResult>(response);
}

export async function submitFeedback(request: FeedbackRequest): Promise<void> {
  const response = await fetch(`${apiBaseUrl}/api/feedback`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(request)
  });

  await readJsonResponse<{ ok: true }>(response);
}

async function readJsonResponse<T>(response: Response): Promise<T> {
  const payload = (await response.json().catch(() => null)) as T | CheckError | null;
  const isObjectPayload = typeof payload === "object" && payload !== null;

  if (!response.ok || !isObjectPayload || ("ok" in payload && payload.ok === false)) {
    const message =
      isObjectPayload && "message" in payload ? payload.message : `Request failed with ${response.status}.`;
    throw new Error(message);
  }

  return payload as T;
}
